import React from 'react'

import styles from './__internal__/small-loader.module.css'

/**
 * SmallLoader Component
 *
 * A simple looping loader component.
 *
 * Usage Examples:
 * <SmallLoader variant="light" />
 * <SmallLoader variant="dark" />
 */
export function SmallLoader({
  variant,
  ...props
}: Omit<React.JSX.IntrinsicElements['svg'], 'className'> & {
  readonly variant: 'light' | 'dark'
}) {
  return (
    <svg
      aria-label={'Loading'}
      className={`size-6 ${
        variant === 'dark' ? 'text-white' : 'text-acorns-stone-light'
      }`}
      fill={'none'}
      role={'status'}
      viewBox={'0 0 24 24'}
      xmlns={'http://www.w3.org/2000/svg'}
      {...props}
    >
      <g className={styles.loader}>
        <circle
          cx={'12'}
          cy={'12'}
          fill={'none'}
          r={'9.5'}
          stroke={'currentColor'}
          strokeWidth={'3'}
        />
      </g>
    </svg>
  )
}
